import { MenuItem } from 'primeng/api';

export const SIDEBAR_ITEMS: MenuItem[] = [
  {
    label: 'sidebar.devices',
    icon: 'heroCog8Tooth',
    routerLink: ['/devices'],
  },
  {
    label: 'sidebar.users',
    icon: 'heroUsers',
    routerLink: ['/users'],
  },
  {
    label: 'sidebar.logs',
    icon: 'heroExclamationTriangle',
    routerLink: ['/logs'],
  },
  {
    label: 'sidebar.firmware',
    icon: 'heroArrowDownTray',
    routerLink: ['/firmware'],
  },
  {
    label: 'sidebar.settings',
    icon: 'heroCog8Tooth',
    routerLink: ['/settings'],
  },
];
